import { Head, Link } from '@inertiajs/react'
import { Button } from "@/components/ui/button"
import { ArrowLeft } from "lucide-react"
import Form from './Form'

interface AwardContact {
  id: number
  first_name: string
  last_name: string
  phone_office?: string
  phone_mobile?: string
  phone_other?: string
  address_1?: string
  address_2?: string
  city?: string
  state?: string
  postal_code?: string
  email?: string
  notes?: string
  roles?: string[]
}

interface Award {
  id: number
  supplier_id: number
  supplier: {
    id: number
    name: string
  }
  award_contacts_attributes: AwardContact[]
}

interface Props {
  deal: {
    id: number
    name: string
  }
  award: Award
  suppliers: Array<{
    id: number
    name: string
  }>
  errors?: Record<string, string>
}

export default function Edit({ deal, award, suppliers, errors = {} }: Props) {
  return (
    <>
      <Head title={`Edit Award - ${deal.name}`} />
      <div className="container mx-auto py-6 space-y-6 p-6">
        <div className="flex items-center space-x-4">
          <Link href={`/deals/${deal.id}`}>
            <Button variant="outline" size="icon">
              <ArrowLeft className="h-4 w-4" />
            </Button>
          </Link>
          <div>
            <h1 className="text-2xl font-bold tracking-tight">Edit Award</h1>
            <p className="text-sm text-muted-foreground">
              Deal: {deal.name}
            </p>
          </div>
        </div>

        <Form deal={deal} award={award} suppliers={suppliers} errors={errors} />
      </div>
    </>
  )
}
